import { TermsSlugType } from '@cyberkongz/ui';
import { ReactNode } from 'react';

import CKARExperiencePolicyContent from './ck-ar-experience-policy.mdx';
import CKStoreAndEmakiPolicyContent from './ck-store-and-emaki-policy.mdx';
import CookiesPolicyContent from './cookies-policy.mdx';
import GenkaiSagaDisclosuresContent from './genkai-saga-disclosures.mdx';
import KongzKreatorProgramContent from './kongz-kreator-program.mdx';
import PrivacyPolicyContent from './privacy-policy.mdx';
import TermsAndConditionsContent from './terms-and-conditions.mdx';

// TO DO, USE REMARK TO PARSE AUTOMATIC INSTEAD OF DUPLICATION
const TermsAndConditionsHeadings = [
  'General Terms and Conditions',
  'Introduction',
  'Definitions',
  'CyberKongz Definitional Summary',
  'What We Own',
  'General Ownership and Usage Rights',
  'Personal Use',
  'Commercial and Derivative Rights',
  'Adjusting or Delisting CyberKongz Assets',
  'Future Projects',
  'Play & Kollect',
  'Changes to the Dapp',
  'Genkai',
  'SAGA',
  'Intellectual Property',
  'Disclaimer and Indemnification',
  'Disclaimer of Liability for Third-Party Links',
  'No Investment Advice',
  'Taxes',
  'Disclaimer of Value',
  'Age Requirement',
  'Termination',
  'Changes to These Terms',
  'Risk of Smart Contracts, Dapp or the Site/ Platform',
  'Privacy Policy',
  'Governing Law & Dispute Resolution',
  'Waiver and Severability',
  'Entire Agreement',
  'Contact Information',
];

const PrivacyPolicyHeadings = [
  'Information We Collect',
  'Purpose of Data Collection, Processing and/or Retention',
  'Sensitive Personal Information',
  'Legal Basis for Processing',
  'How We Use Your Information',
  'Cookies and Consent',
  'Data Security',
  'International Data Transfers',
  'Limitation of Liability',
  'Third-Party Links and Service Providers',
  `Children's Privacy`,
  'Individual Rights',
  'Complaints and Supervisory Authority',
  'Updates to this Policy',
  'Conclusion and Contact Information',
];

const CookiesPolicyHeadings = [
  'Introduction',
  'What are cookies?',
  'Why do we use cookies?',
  'How can I control cookies?',
  'What about other tracking technologies, like web beacons?',
  'Do you use Flash cookies or Local Shared Objects?',
  'Do you serve targeted advertising?',
  'How often will you update this Cookie Policy?',
  'Detailed Cookies Table',
];

const GenkaiSagaDisclosuresHeading = [
  'Introduction',
  'Definitions',
  'US Purchasers Exclusion',
  'Limited Rights & Utility',
  'Regulatory Compliance',
  'Platform or Project-Specific Risks',
  'Market Liquidity Risks',
  'Jurisdictional Risks',
  'Tax Implications and Financial Advice',
  'No Warranty',
  'No Endorsement or Guarantee',
  'Intellectual Property & Licensing',
  'Prohibited Uses',
  'Regulatory Updates',
  'Educational Resources',
  'Modifications',
  'SAGA Introduction',
  'Ownership and Intellectual Property (“IP”)',
  'SAGA Submission Process',
  'Voluntary Participation',
  'Public Voting',
  'Character Narration and Traits',
  'Transfer of Ownership and SAGA Opt-Out for Successive Owners',
  'Contact Information',
];

const KongzKreatorProgramHeading = [
  'Introduction',
  'Definitions',
  'Eligibility and Registration',
  'Press Kit',
  'Modification and Termination',
  'Content Submission and Intellectual Property',
  'Intellectual Property Rights Post-Termination',
  'Ethical Guidelines',
  'Compensation and Rewards',
  'Evaluation and Process',
  'Responsibilities and Disclaimers',
  'Liability Limitations',
  'Data Protection and Privacy',
  'Governing Law and Dispute Resolution',
  'Kreator Feedback',
  'Contact Information',
];

const TempEmapkiStoreHeading = [
  'Introduction',
  'General Terms',
  'Products',
  'Ordering & Payment',
  'Shipping & Delivery',
  'Returns & Refunds',
  'Warranties & Disclaimers',
  'Intellectual Property Rights',
  'Privacy Policy & Data Related Terms',
  'Dispute Resolution & Governing Law',
  'Contact Information',
  'Miscellaneous',
];

const CKARExperienceHeading = [
  'Introduction and Scope',
  'Access and Data Collection',
  'User Responsibilities',
  'Privacy and Data Handling',
  'Ownership and Licensing',
  'Liability and Disclaimers',
  'Termination of Access',
  'Dispute Resolution',
  'Amendments to Terms',
  'Acceptance of Terms',
];

// TO DO ADD LAST_UPDATED_DATE/VERSION TO DISPLAY NOTICE IF SMTH CHANGED
export const TERMS_CONTENT: {
  [key in TermsSlugType]: {
    content: ReactNode;
    headings: string[];
  };
} = {
  'terms-and-conditions': {
    content: <TermsAndConditionsContent />,
    headings: TermsAndConditionsHeadings,
  },
  'privacy-policy': {
    content: <PrivacyPolicyContent />,
    headings: PrivacyPolicyHeadings,
  },
  'cookies-policy': {
    content: <CookiesPolicyContent />,
    headings: CookiesPolicyHeadings,
  },
  'genkai-saga-disclosures': {
    content: <GenkaiSagaDisclosuresContent />,
    headings: GenkaiSagaDisclosuresHeading,
  },
  'kongz-kreator-program': {
    content: <KongzKreatorProgramContent />,
    headings: KongzKreatorProgramHeading,
  },
  'ck-store-and-emaki-policy': {
    content: <CKStoreAndEmakiPolicyContent />,
    headings: TempEmapkiStoreHeading,
  },
  'ck-ar-experience-policy': {
    content: <CKARExperiencePolicyContent />,
    headings: CKARExperienceHeading,
  },
};
